import { COUNTRIES } from "../../constants/common/common";

/**
 *
 * @param {*} catalogId
 * @param {*} categoryId
 * @param {*} currencyUomId
 * @param {*} productId
 * @returns
 */
export const GET_PRODUCT_DETAILS_URL = (country = "india", urlIdentifier) => {
  return `/productapi/api/rest/v1.3/getProductDetails?urlIdentifier=${country}/${urlIdentifier}&currencyUomId=INR&catalogId=${country}`;
};

/**
 *
 * @param {*} catalogId
 * @param {*} categoryId
 * @param {*} currencyUomId
 * @param {*} productId
 * @returns
 */
export const UPDATE_PRODUCT_DETAILS_URL = (productId, currencyUomId, catalogId, categoryId) => {
  return `/productapi/api/rest/v1.3/getProductDetails?productId=${productId}&currencyUomId=${currencyUomId}&catalogId=${catalogId}&categoryId=${categoryId}`;
};

/**
 *
 * @param {*} productId
 * @param {*} domainId
 * @param {*} NoOfReviewRequest
 * @returns
 */
export const GET_PRODUCT_REVIEWS_URL = (productId, domainId, NoOfReviewRequest) => {
  return `/moody/v1/product/reviews?productId=${productId}&domainId=${domainId}&size=${NoOfReviewRequest}`;
};

/**
 *
 * @param {*} fileName image to be uploaded
 * @returns API endpoint
 */
export const AWS_PRE_SIGNED_URL = (fileName) => {
  return `/productapi/api/rest/v1.3/getAWSPreSignedUrl?fileName=${fileName}`;
};

/**
 *
 * @param {*} params image to be uploaded
 * @returns API endpoint
 */
export const CUSTOMIZABLE_CONTENT_URL = ({ urlIdentifier, productId }) => {
  return `/info/_pp/m.fnp.com/${urlIdentifier}?pid=${productId}&hf=N&requestSource=MRPLP`;
};

/**
 * Returns the URL for the calendar footer message.
 *
 * @function
 * @returns {string} The URL string for the calendar footer message.
 */
export const CALENDER_MSG_URL = () => {
  return "/chocolate/v1/global/static/web/calenderfootermsg";
};

/**
 * Get Product Stock Available details.
 * @param {*} productId
 * @returns
 */
export const GET_PRODUCT_STOCK_AVAILABLE_URL = (productId, pincode) => {
  return `/productapi/api/rest/v1.3/isProductStockAvailable?productId=${productId}${pincode ? `&pincode=${pincode}` : ""}`;
};

/**
 * Returns the Out of stock Redirection URL for Msite & Dsite.
 *
 * @function
 * @returns {string} The URL string for the Out of stock Redirection.
 */
export const OUT_OF_STOCK_URL = () => {
  return "/chocolate/v1/global/static/web/out_of_stock_redirection";
};

/**
 * Returns the Price Surge Details URL for Msite & Dsite.
 *
 * @function
 * @param {*} productId
 * @returns {string} The URL string for the Price Surge Details.
 */
export const PRICE_SURGE_DETAILS_ENDPOINT = (productId) => {
  return `/control/getPriceSurgeForProductId?productId=${productId}`;
};

/**
 * Returns the Price Surge Details URL for Msite & Dsite.
 *
 * @function
 * @param {*} productId
 * @returns {string} The URL string for the Price Surge Details.
 */
export const PDP_FOOTER_LINKS = () => {
  return `/chocolate/v1/global/static/web/pdp_footer_links`;
};

/**
 * Returns the Sale Nudge Config URL for Msite & Dsite.
 *
 * @function
 * @returns {string} The URL string for the Sale Nudge Config.
 */
export const GET_SALE_NUDGE_CONFIG = () => {
  return `/chocolate/v1/global/static/web/product-sale-nudge-config`;
};
/** */
export const PDP_SUGGESTION = (productName) => {
  return `/search/v1/category/suggestions?geoId=india&keyword=${encodeURIComponent(productName)}`;
};

/**
 * Returns the Product by URL endpoint.
 *
 * @function
 * @param {string} urlIdentifier - The product URL identifier/slug.
 * @returns {string} The URL string for the product by URL endpoint.
 */
export const GET_PRODUCT_BY_URL = (country, urlIdentifier) => {
  return `/search/v1/product-by-url?urlIdentifier=${country}/${urlIdentifier}`;
};

/**
 * Builds the Pay Later configuration API path.
 * Used to fetch static web configuration for the FNP Pay Later feature.
 *
 * @function PAY_LATER_CONFIG
 * @returns {string} API endpoint path
 */
export const PAY_LATER_CONFIG = () => {
  return `/chocolate/v1/global/static/web/fnp-pay-later`;
};

/**
 * Builds the Swipe API path.
 *
 * @function IS_SWIPE_ENABLE
 * @returns {string} API endpoint path
 */
export const IS_SWIPE_ENABLE = () => {
  return `/productapi/api/rest/v1.3/enablePaymentSwipe`;
};

/** PDP CMS batch segment (e.g. `/chocolate/v1/cms-batch/pdp?paths=...`). */
export const PDP_CMS_BATCH_ID = "pdp";

/**
 * Relative CMS paths used as keys in the batch response map.
 */
export const PDP_BATCH_API_PATHS = {
  ANALYTICS: "/pdp/analytics",
  APP_REDIRECT_BANNER: "/global/static/web/mobile/fnp_app_redirect",
  OFFERS_MOBILE: "/global/static/web/mobile/fnp_offer_modules_json",
  OFFERS_DESKTOP: "/global/static/web/desktop/fnp_offer_modules_json",
  PDP_FOOTER_LINKS: "/global/static/web/pdp_footer_links",
  FREE_DELIVERY_BANNER: "/global/static/web/freedelivery",
  FREE_DELIVERY_TAG_PDP: "/global/static/web/freedeliverytagforpdp",
};

/**
 * TTL (ms) for PDP CMS batch in `withServerCache` on each Next.js Node process.
 */
export const PDP_CMS_BATCH_SERVER_CACHE_TTL_MS = 600000;

/**
 * @param {boolean} isMobile
 * @returns {string}
 */
export const getPdpOffersBatchPath = (isMobile) =>
  isMobile ? PDP_BATCH_API_PATHS.OFFERS_MOBILE : PDP_BATCH_API_PATHS.OFFERS_DESKTOP;

/**
 * @param {string[]} pathsArray
 * @returns {string}
 */
export const GET_PDP_BATCH_API_URL = (pathsArray) => {
  const pathsQuery = pathsArray.map((path) => `paths=${path}`).join("&");
  return `/chocolate/v1/cms-batch/${PDP_CMS_BATCH_ID}?${pathsQuery}`;
};

/**
 * Menu is excluded — heavy and identical across pages, fetched client-side by `<Header>` instead.
 *
 * @param {Object} params
 * @param {boolean} params.isMobile
 * @param {string} params.catalogId
 * @returns {string[]}
 */
export const buildPdpBatchApiPaths = ({ isMobile, catalogId }) => {
  const isDomestic = catalogId === COUNTRIES.INDIA;
  const paths = [
    PDP_BATCH_API_PATHS.ANALYTICS,
    getPdpOffersBatchPath(isMobile),
    ...(isMobile ? [PDP_BATCH_API_PATHS.APP_REDIRECT_BANNER] : []),
    ...(isDomestic
      ? [
          PDP_BATCH_API_PATHS.PDP_FOOTER_LINKS,
          PDP_BATCH_API_PATHS.FREE_DELIVERY_BANNER,
          PDP_BATCH_API_PATHS.FREE_DELIVERY_TAG_PDP,
        ]
      : []),
  ].filter(Boolean);

  return paths;
};

/**
 * Stable empty mapped batch used on fetch/cache errors.
 * @returns {Object}
 */
export const getPdpBatchEmptyMapped = () => ({
  offerDataResponse: [],
  analytics: {},
  pdpFooterLinks: {},
  appRedirectBannerResponse: {},
  freeBannerData: null,
  showFreeDeliveryTag: {},
});

/**
 * Maps PDP batch API response.
 *
 * @param {Object} batchResponse
 * @param {Object} params
 * @param {boolean} params.isMobile
 * @returns {Object}
 */
export const mapPdpBatchApiResponse = (batchResponse, { isMobile }) => {
  if (!batchResponse || typeof batchResponse !== "object") {
    return getPdpBatchEmptyMapped();
  }

  const offersPath = getPdpOffersBatchPath(isMobile);
  const rawOffers = batchResponse[offersPath]?.content;
  const offerDataResponse = Array.isArray(rawOffers) ? rawOffers : [];

  return {
    offerDataResponse,
    analytics: batchResponse[PDP_BATCH_API_PATHS.ANALYTICS]?.content || {},
    pdpFooterLinks: batchResponse[PDP_BATCH_API_PATHS.PDP_FOOTER_LINKS]?.content || {},
    appRedirectBannerResponse:
      isMobile && batchResponse[PDP_BATCH_API_PATHS.APP_REDIRECT_BANNER]?.content
        ? batchResponse[PDP_BATCH_API_PATHS.APP_REDIRECT_BANNER].content
        : {},
    freeBannerData: batchResponse[PDP_BATCH_API_PATHS.FREE_DELIVERY_BANNER]?.content || null,
    showFreeDeliveryTag: batchResponse[PDP_BATCH_API_PATHS.FREE_DELIVERY_TAG_PDP]?.content || {},
  };
};
